(() => {

  let lastScrollY = 0;
  let lastOpener = null;

  const restoreScroll = () => {
    window.scrollTo({ top: lastScrollY, left: 0, behavior: 'instant' });
  };

  const openModalById = (id, opener) => {
    const modal = document.getElementById(id);
    if (!modal || !modal.hidden) return;

    lastScrollY = window.scrollY;
    lastOpener = opener || null;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.dataset.ghlPopupOpen = 'true';
    document.body.style.overflow = 'hidden';

    // focus close button for accessibility, without scrolling the page to it
    const closeBtn = modal.querySelector('[data-ghl-close]');
    closeBtn && closeBtn.focus({ preventScroll: true });
  };

  const closeModal = (modal) => {
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    delete document.body.dataset.ghlPopupOpen;
    document.body.style.overflow = '';
    restoreScroll();
    // The form embed can still move the page once the popup is hidden. For a moment after
    // closing, undo any scroll the visitor didn't make.
    const undoJump = () => restoreScroll();
    const stopGuard = () => {
      window.removeEventListener('scroll', undoJump);
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach((type) => window.removeEventListener(type, stopGuard, true));
    };
    window.addEventListener('scroll', undoJump);
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach((type) => window.addEventListener(type, stopGuard, true));
    setTimeout(stopGuard, 1000);
    lastOpener && lastOpener.focus({ preventScroll: true });
  };

  // Open trigger anywhere on page:
  // <button data-ghl-modal-open="GhlPopup-SECTIONID">Open</button>

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-ghl-modal-open]');
  if (opener) {
    e.preventDefault();
    const id = opener.getAttribute('data-ghl-modal-open');
    if (id) openModalById(id, opener);
    return;
  }

  const closer = e.target.closest('[data-ghl-close]');
  if (closer) {
    e.preventDefault();
    const modal = closer.closest('[data-ghl-popup]');
    if (modal) closeModal(modal);
  }
}, true);

  // Escape closes the currently open modal
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openModal = document.querySelector('[data-ghl-popup]:not([hidden])');
    closeModal(openModal);
  });
})();
